import Vue from 'vue'
import 'vue-visual/index.css'
import Visual from 'vue-visual'
import qs from 'query-string'

let supportsWebp = false;
if (window?.Modernizr){
    window.Modernizr.on('webp', (bool) => {
        supportsWebp = bool
    })
}


Vue.component('visual', {
    name: 'VueVisual',
    functional: true,
    render: function(create, {props, data, children}) {
        return create(Visual, {
            ...data,
            props: {
                // Custom default props
                // lazyLoad: true,

                background: 'cover',
                load: 'visible',
                transition: 'vv-fade',
                assetMutator: (asset, src) =>{
                    if (supportsWebp && src?.match(/^(https?\:)?\/\/images\.ctfassets\.net\/.+\.(jpe?g|gif|png|webp)($|\?)/i)){
                        // Set the format to webp
                        let { url, query } = qs.parseUrl(src);
                        query.fm = 'webp'
                        query.fl = undefined // Clear progressive flag
                        src = `${url}?${qs.stringify(query)}`
                        return src;
                    }
                },
                ...props
            }
        }, children);
    }
});
